import { Device } from 'DeviceUtils';

export const getBackgroundByDevice = (background) => {
    if (Device.isTabletOrWeb) {
        return background[1].url;
    }
    return background[2].url;
};
